import React, { lazy } from "react";

import { RoutedTabs, TabDefinition } from "fond/widgets/RoutedTabs";

import { SettingsTabContent } from "../common.styles";

const AccountDetailsTab = lazy(() => import("./AccountDetails"));
const SubscriptionDetailsTab = lazy(() => import("./SubscriptionDetails"));
const AccountDefaultsTab = lazy(() => import("./AccountDefaults"));

const tabs: TabDefinition[] = [
  { label: "Details", path: "details", component: AccountDetailsTab, event: "settings.account.details.viewed" },
  { label: "Subscription", path: "subscription", component: SubscriptionDetailsTab, event: "settings.account.subscription.viewed" },
  { label: "Defaults", path: "defaults", component: AccountDefaultsTab, event: "settings.account.defaults.viewed" },
];

const AccountManagement: React.FC = () => {
  return <RoutedTabs ContentContainer={SettingsTabContent} prefix="/settings/account" tabs={tabs} data-testid="account-management" />;
};

export default AccountManagement;
